/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'settings': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M17 6a3 3 0 10-2.815-4H0v2h14.185A3 3 0 0017 6zm0-4a1 1 0 11-1 1 1 1 0 011-1zM7 6a3 3 0 00-2.815 2H0v2h4.185a2.982 2.982 0 005.631 0H20V8H9.815A3 3 0 007 6zm0 4a1 1 0 111-1 1 1 0 01-1 1zm10 2a3 3 0 00-2.815 2H0v2h14.185A2.995 2.995 0 1017 12zm0 4a1 1 0 111-1 1 1 0 01-1 1z" _fill="#474950" fill-rule="evenodd"/>'
  }
})
